<template>
  <div class="feedback">
    <div class="mtop">
      <div class="m-top-text">
        <div class="userInfo">
          <img :src=imageUrl alt="">
          <span class="text"> <span class="uname">{{user.nickName}}</span>
            <br>{{agent}}&nbsp;&nbsp;当前用户等级&nbsp;&nbsp;{{userLevel}}&nbsp;|&nbsp;&nbsp;&nbsp;<i
              class="el-icon-caret-bottom"></i> <a href="javascript:void(0)" @click="toAccount"
              style="color:white">更多信息</a></span>
        </div>
        <div class="main-nav">
          <ul>
            <li :class="menu[0].active"><a href="javascript:void(0)"
                @click="changeStatus('waitPay')">待支付<span>{{userCenterCount.orderWaitPayCount}}</span></a></li>
            <li :class="menu[1].active"><a href="javascript:void(0)"
                @click="changeStatus('producing')">生产中<span>{{userCenterCount.orderProducingCount}}</span></a></li>
            <li :class="menu[2].active"><a href="javascript:void(0)"
                @click="changeStatus('produced')">待收货<span>{{userCenterCount.orderProducedCount}}</span></a></li>
            <li :class="menu[3].active"><a href="javascript:void(0)"
                @click="voucher('allVoucherCount')">代金券<span>{{userCenterCount.allVoucherCount}}</span></a></li>
            <li :class="menu[4].active"><a href="javascript:void(0)"
                @click="voucher('vailableCount')">未使用<span>{{userCenterCount.voucherCount}}</span></a></li>
            <li :class="menu[5].active"><a href="javascript:void(0)"
                @click="totalFile('totalFile')">总文件<span>{{userCenterCount.producedFileCount}}</span></a></li>
          </ul>
        </div>
        <!-- <div class="userreset">
            <span><i class="el-icon-s-tools"></i> 个人设置</span>
          </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import eventBus from '../../common/eventBus.js'
export default {
  name: 'feedback',
  components: {
  },
  props: ['user', 'userCenterCount', 'userLevel', 'agent', 'active', 'topMenuStatus'],
  data () {
    return {
      menu: [
        {
          name: 'waitPay',
          active: ''
        },
        {
          name: 'producing',
          active: ''
        },
        {
          name: 'produced',
          active: ''
        },
        {
          name: 'allVoucherCount',
          active: ''
        },
        {
          name: 'vailableCount',
          active: ''
        },
        {
          name: 'totalFile',
          active: ''
        }
      ],
      imageUrl: './static/mrtx.png'
    }
  },
  mounted () {
    eventBus.$on('showAvatar', xxx => {
      let imageUrl = JSON.parse(sessionStorage.getItem('imageUrl'))
      this.imageUrl = imageUrl
    })
    let imageUrl = JSON.parse(sessionStorage.getItem('imageUrl'))
    if (imageUrl !== 'data:image/png;base64,') {
      this.imageUrl = imageUrl
    }
    this.getMessageCount()
    this.timer = setInterval(this.getMessageCount, 40000)
  },
  methods: {
    toAccount () {
      this.activeIndex2 = '0'
      eventBus.$emit('toAccountMenu')
      this.$router.push('/home/account')
    },
    changeStatus (val) {
      this.menu.forEach((item, index) => {
        if (item.name === val) {
          this.menu[index].active = 'active'
        } else {
          this.menu[index].active = ''
        }
      })
      if (this.$route.name !== 'orders') {
        this.$router.push({ name: 'orders', params: { status: val } })
      }
      this.$emit('changeStatus', val)
    },
    totalFile (val) {
      this.menu.forEach((item, index) => {
        if (item.name === 'totalFile') {
          this.menu[index].active = 'active'
        } else {
          this.menu[index].active = ''
        }
      })
      this.$router.push({ name: 'cloudDisk', params: { status: val } })
      this.$emit('cloudDisk')
    },
    voucher (val) {
      this.menu.forEach((item, index) => {
        if (item.name === val) {
          this.menu[index].active = 'active'
        } else {
          this.menu[index].active = ''
        }
      })
      this.$router.push({ name: 'voucher', params: { status: val } })
      this.$emit('voucher')
    },
    getMessageCount () {
      eventBus.$emit('getMessageCount')
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  watch: {
    active (val) {
      if (!val) {
        this.menu.forEach((item, index) => {
          this.menu[index].active = ''
        })
        this.$emit('defaultActive', true)
      }
    },
    topMenuStatus (val) {
      this.menu.forEach((item, index) => {
        if (item.name === val) {
          this.menu[index].active = 'active'
        } else {
          this.menu[index].active = ''
        }
      })
    }
  }
}
</script>

<style lang="less">
.feedback {
  .mtop {
    height: 120px;
    background-color: #122644;
    margin-bottom: 15px;
    position: relative;
    z-index: 99;
    .m-top-text {
      width: 1100px;
      margin: 0 auto;
      padding-left: 70px;
      .userInfo {
        color: #fff;
        display: inline;
        padding-left: 10px;
        img {
          float: left;
          margin-top: 35px;
          width: 100px;
          height: 100px;
          border-radius: 50px;
        }
        .text {
          float: left;
          margin-top: 38px;
          margin-left: 20px;
          line-height: 2em;
          .uname {
            font-size: 20px;
          }
        }
      }
      .main-nav {
        float: left;
        margin-top: 35px;
        font-size: 16px;
        margin-left: 60px;
        ul {
          li {
            height: 20px;
            line-height: 20px;
            float: left;
            padding: 0 15px;
            border-right: 2px solid #c3c7cd;
            span {
              display: block;
              margin-top: 10px;
              text-align: center;
            }
            a {
              color: #c3c7cd;
            }
          }
          li:last-child {
            border-right: none;
          }
          li.active {
            a {
              color: #65a9c0;
            }
          }
          li:hover {
            a {
              color: #91b4c0;
            }
          }
        }
      }
      .userreset {
        float: right;
        margin-top: 35px;
        span {
          display: inline-block;
          color: #c3c7cd;
          padding: 5px 15px;
          border: 1px solid #c3c7cd;
          border-radius: 15px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/userCenter/feedback.vue